import React from 'react';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import Row from "react-bootstrap/Row";
import Storage from "./Storage";
import axios from 'axios';

import Alert from "./Alert";

export default class LoginForm extends React.Component {
    state = {
        token: '',
        alert: '',
    };

    render() {
        if (!!this.state.alert) {
            return <Alert>{this.state.alert}</Alert>
        }
        return (
            <Container>
                <Row>
                    <div className="col-4 offset-4 mt-5">
                        <Form onSubmit={this.handleSubmit}>
                            <Form.Group>
                                <InputGroup>
                                    <Form.Control
                                        type="text"
                                        name="token"
                                        value={this.state.token}
                                        onChange={this.handleChange}
                                        placeholder="Token"
                                    />
                                </InputGroup>
                            </Form.Group>
                            <div className="text-right">
                                <Button type="submit" className="btn-success">Sign in</Button>
                            </div>
                        </Form>
                    </div>
                </Row>
            </Container>
        )
    }

    handleSubmit = (e) => {
        e.preventDefault();

        axios.get('api/v1/admin/login', {headers: {'Authorization': 'Bearer ' + this.state.token}})
            .then(response => {
                if (response.status === 200) {
                    Storage.setToken(this.state.token);
                    window.location.replace('/');
                } else {
                    this.setState({alert: 'Received ' + response.status + ' status code. Expected 200.'})
                }
            }).catch(error => {
            if (error.response) {
                if (error.response.status === 401) {
                    this.setState({alert: 'Invalid token'})
                } else {
                    this.setState({alert: 'Error on sending token: ' + error.response.status});
                }
            } else {
                this.setState({alert: JSON.stringify(error)});
            }
        });
    };

    handleChange = (e) => {
        this.setState({token: e.target.value, alert: ''});
    };
}